
























































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { format2DigitsVariant } from '@/utils/numbers';
import DNumberbox from "@/components/DNumberbox/numberbox.vue";
import _ from 'lodash';

import PresetService from '@/services/user_preset_service';
import { EcoObjectType, YearType } from '@/services/models-service';
import { months_map } from '@/constants';
import YearService from '@/services/years-service';
import NumberSpan from '@/components/InputComponents/number-span.vue';

@Component({
  name: 'BlockLossesInputs',
  components: {
    DNumberbox,
    NumberSpan
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: any;
  @PropSync('portion') public mainBlock!: any;
  @PropSync('secondaryPortion') public secondaryBlock!: any;
  @Prop() public periodName!: string;
  @Prop() public blockAccept!: any;
  @Prop() public blockId!: string;
  @Prop({default: false}) public editingBlock!: boolean;
  @Prop({default: false}) public showSecondaryCut!: boolean;
  @Prop({default: false}) public initiated!: boolean;
  @Prop({default: false}) public aggregate!: boolean;
  @Prop() public facilities!: any;
  @Prop({default: null}) public pasteData!: number[][] | null;
  @Prop({default: 0}) public pasteStartRow!: number;
  @Prop({default: 0}) public pasteStartCol!: number;
  @Prop({default: false}) public isPasteTarget!: boolean;
  
  // НОВЫЙ ПРОП: выбранная строка из родителя
  @Prop({default: null}) public selectedRow!: any;

  public focusIndex: null |  number = null;
  public year_ds: YearType[] = YearService.YearList;
  public showPasteHint: boolean = false;
  
  // Локальная позиция для внутренних операций (вставка, навигация)
  public currentRowIndex: number = -1;
  public currentColIndex: number = 0;

  @Watch('selectedRow', {deep: true})
  changeRow(){
    if (this.selectedRow.period === this.periodName && this.selectedRow.blockId === this.blockId){
      this.currentRowIndex = this.selectedRow.rowIndex
    } else {
      this.currentRowIndex = -1
    }
  }

  formatReadOnlyValue(val: number) {
    return this.$options.filters?.numberFormat(val, 2) || format2DigitsVariant.format(val);
  }

  get cssVars() {
    return {
      '--width': PresetService.tableWidth + 'px'
    }
  }

  public number_format = {
    decimal: '.',
    separator: ' ',
    prefix: '',
    precision: 2,
  };

  public keys = [
    {id: 1, name: 'first'},
    {id: 2, name: 'second'},
    {id: 3, name: 'third'},
    {id: 4, name: 'fourth'},
    {id: 5, name: 'fifth'},
    {id: 6, name: 'sixth'},
  ]

  get route() {
    return this.$route.name
  }

  get readOnly() {
    if(this.blockAccept) {
      return true;
    } else {
      return false;
    }
  }

  getCellData(key: string) {
    return {
      key,
      data: this.mainBlock[key],
      rowIndex: this.keys.findIndex(k => k.name === key),
      isEditable: !this.readOnly && this.editingBlock && !this.aggregate && !this.checkExistence
    };
  }

  focusOutNumberBox(data: any) {
    this.focusIndex = null;
  }

  showNumberBox(data: any) {
    if(!this.aggregate && !this.checkExistence) {
      this.focusIndex = data.id_heat_carrier;
      this.updateCurrentPosition(data.id_heat_carrier);
    }
  }

  updateCurrentPosition(id_heat_carrier: number) {
    const keyIndex = this.keys.findIndex(key => {
      return this.mainBlock[key.name] && this.mainBlock[key.name].id_heat_carrier === id_heat_carrier;
    });
    
    if (keyIndex !== -1) {
      this.currentRowIndex = keyIndex;
      this.currentColIndex = 0;
    }
  }

  // ИЗМЕНЕННЫЙ МЕТОД: эмитит событие вверх вместо локального состояния
  handleCellClick(rowKey: string, rowIndex: number) {
    console.log(`Клик на ячейку: ${rowKey} -> rowIndex: ${rowIndex}, period: ${this.periodName}, block: ${this.blockId}`);
    
    // Эмитим событие родителю с информацией о кликнутой строке
    this.$emit('row-clicked', {
      rowIndex: rowIndex,
      period: this.periodName,
      blockId: this.blockId
    });
    
    // Обновляем локальную позицию для внутренних операций
    this.currentRowIndex = rowIndex;
    this.currentColIndex = 0;
  }

  setColumnPosition(colIndex: number) {
    this.currentColIndex = Math.max(0, colIndex);
    this.showPasteHint = true;
    setTimeout(() => { this.showPasteHint = false; }, 2000);
    console.log(`Установлена позиция столбца: ${this.currentColIndex + 1}, текущая позиция: (${this.currentRowIndex + 1}, ${this.currentColIndex + 1})`);
  }

  getKeyByRowIndex(rowIndex: number): string | null {
    if (rowIndex >= 0 && rowIndex < this.keys.length) {
      const keyName = this.keys[rowIndex].name;
      console.log(`getKeyByRowIndex(${rowIndex}) = ${keyName}`);
      return keyName;
    }
    console.log(`getKeyByRowIndex(${rowIndex}) = null (индекс вне диапазона)`);
    return null;
  }

  isRowEditable(rowIndex: number): boolean {
    const keyName = this.getKeyByRowIndex(rowIndex);
    if (!keyName) return false;
    
    return !this.readOnly && 
           this.editingBlock && 
           !this.aggregate && 
           !this.checkExistence &&
           this.mainBlock[keyName];
  }

  getKeyNameByData(data: any): string {
    for (const key of this.keys) {
      if (this.mainBlock[key.name] === data) {
        return key.name;
      }
    }
    return '';
  }

  changeFormat(data:any) {
    return this.$options.filters?.numberFormat(data, 3) || this.$options.filters?.numberFormat(data, 0);
  }

  correctFormat(data:any, e:any) {
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    if (this.focusIndex === data.id_heat_carrier) {
      e.component.focus();
      Vue.nextTick(() => {
        inputEl.selectionStart = 0;
        inputEl.selectionEnd = inputEl.value.length;
      })
    }
  }

  @Watch('mainBlock.first', { deep: true })
  @Watch('mainBlock.second', { deep: true })
  @Watch('mainBlock.third', { deep: true })
  @Watch('mainBlock.fourth', { deep: true })
  @Watch('mainBlock.fifth', { deep: true })
  @Watch('mainBlock.sixth', { deep: true })
  seekChanges(data: any) {
    if (this.initiated) {
      if (data.vol_te === null) {
        data.vol_te = 0;
        return
      }
      Vue.nextTick(() => {
        const changes = {block: this.blockId, period: this.periodName}
        this.$emit('changes', changes);
      });
    }
  }

  @Watch('pasteData')
  onPasteDataChange() {
    if (this.pasteData && this.isPasteTarget) {
      this.applyPasteDataFromParent();
    }
  }

  @Watch('isPasteTarget')
  onPasteTargetChange() {
    if (this.pasteData && this.isPasteTarget) {
      this.applyPasteDataFromParent();
    }
  }

  get checkExistence() {
    const data = this.mainBlock.total;
    if (data.id_eco_facility && !this.aggregate) {
      const obj_match = this.facilities.find((obj: EcoObjectType) => obj.id === data.id_eco_facility);
      const default_year = this.year_ds.find(y => y.id === PresetService.currentPreset.id_year);
      if (obj_match && default_year) {
        const objBd = new Date(obj_match.date_from);
        const fromMonth = objBd.getMonth() + 1;
        const fromYear = objBd.getFullYear();
        if (fromYear < default_year.name || (fromYear === default_year.name && months_map[data.month] >= fromMonth)) {
          return false
        } else {
          return true
        }
      }
    }
  }

  defineCapacity(e: any) {
    if (this.checkExistence && !e.target.getAttribute('title')) {
      const content = 'Объект не существует в этом месяце'
      e.target.setAttribute('title', content);
    }
  }

  handlePaste(event: ClipboardEvent) {
    if (this.readOnly || !this.editingBlock || this.aggregate) {
      return;
    }

    const clipboardData = event.clipboardData;
    if (!clipboardData) {
      return;
    }

    const pastedText = clipboardData.getData('text');
    if (!pastedText) {
      return;
    }

    event.preventDefault();

    const rows = pastedText.trim().split('\n');
    const matrix: number[][] = [];

    for (const row of rows) {
      const cells = row.split('\t');
      const rowData: number[] = [];
      
      for (const cell of cells) {
        const trimmedCell = cell.trim();
        if (trimmedCell) {
          let cleanValue = trimmedCell
            .replace(/\s/g, '')
            .replace(',', '.');
          
          const numValue = parseFloat(cleanValue);
          rowData.push(isNaN(numValue) ? 0 : numValue);
        } else {
          rowData.push(0);
        }
      }
      
      if (rowData.length > 0) {
        matrix.push(rowData);
      }
    }

    this.$emit('pasteRequest', {
      matrix,
      blockId: this.blockId,
      periodName: this.periodName,
      startRow: this.currentRowIndex,
      startCol: this.currentColIndex
    });

    if (matrix.length === 1 && matrix[0].length === 1) {
      this.applyMatrixToBlock(matrix);
    }
  }

  applyMatrixToBlock(matrix: number[][]) {
    if (matrix.length === 0) {
      return;
    }

    console.log(`Вставка матрицы ${matrix.length}x${matrix[0]?.length || 0} начиная с позиции (${this.currentRowIndex}, ${this.currentColIndex})`);
    
    const currentKey = this.getKeyByRowIndex(this.currentRowIndex);
    if (!currentKey) {
      console.log('Не удалось определить текущий ключ');
      return;
    }
    
    console.log(`Текущий ключ: ${currentKey}`);
    
    if (matrix.length === 1 && matrix[0].length === 1) {
      const value = matrix[0][0];
      
      if (this.isRowEditable(this.currentRowIndex)) {
        if (this.mainBlock[currentKey]) {
          if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
            this.mainBlock[currentKey].vol_te = value;
            console.log(`Вставлено значение ${value} в ${currentKey}`);
          } else {
            this.mainBlock[currentKey].vol_te = 0;
            console.log(`Некорректное значение ${value}, установлено 0 в ${currentKey}`);
          }
        }
      }
    } else {
      const isHorizontal = matrix.length === 1 && matrix[0].length > 1;
      
      if (isHorizontal) {
        console.log('Обнаружена горизонтальная вставка');
        this.applyHorizontalMatrix(matrix);
      } else {
        console.log('Обнаружена вертикальная вставка');
        this.applyVerticalMatrix(matrix);
      }
    }

    Vue.nextTick(() => {
      const changes = {block: this.blockId, period: this.periodName};
      this.$emit('changes', changes);
    });
  }

  applyVerticalMatrix(matrix: number[][]) {
    for (let rowIndex = 0; rowIndex < matrix.length; rowIndex++) {
      const targetRowIndex = this.currentRowIndex + rowIndex;
      const targetKey = this.getKeyByRowIndex(targetRowIndex);
      
      if (!targetKey || !this.isRowEditable(targetRowIndex)) {
        console.log(`Строка ${targetRowIndex + 1} (${targetKey}) недоступна для редактирования`);
        continue;
      }
      
      const row = matrix[rowIndex];
      if (row.length === 0) continue;
      
      const colIndex = Math.min(this.currentColIndex, row.length - 1);
      const value = row[colIndex];
      
      console.log(`Строка ${rowIndex + 1}: доступно ${row.length} столбцов, выбран столбец ${colIndex + 1}, значение: ${value}`);
      
      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        this.mainBlock[targetKey].vol_te = value;
        console.log(`Вставлено значение ${value} в ${targetKey} из столбца ${colIndex + 1}`);
      } else {
        this.mainBlock[targetKey].vol_te = 0;
        console.log(`Некорректное значение ${value}, установлено 0 в ${targetKey}`);
      }
    }
  }

  handleKeyDown(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
      return;
    }
  }

  handleFocus(event: FocusEvent) {
    if (!this.readOnly && this.editingBlock && !this.aggregate) {
      this.showPasteHint = true;
      setTimeout(() => {
        this.showPasteHint = false;
      }, 3000);
    }
  }

  handleBlur(event: FocusEvent) {
    this.showPasteHint = false;
  }

  applyHorizontalMatrix(matrix: number[][]) {
    if (matrix.length === 0) return;
    
    const firstRow = matrix[0];
    if (!firstRow || firstRow.length === 0) return;
    
    console.log(`Горизонтальная вставка: ${firstRow.length} значений начиная с ${this.currentRowIndex + 1} строки`);
    console.log('MAIN CBLOCK');
    console.log(this.mainBlock);
    
    for (let colIndex = 0; colIndex < firstRow.length; colIndex++) {
      const targetRowIndex = this.currentRowIndex + colIndex;
      const targetKey = this.getKeyByRowIndex(targetRowIndex);
      const value = firstRow[colIndex];
      
      if (!targetKey || !this.isRowEditable(targetRowIndex)) {
        console.log(`Строка ${targetRowIndex + 1} (${targetKey}) недоступна для редактирования`);
        continue;
      }
      
      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        this.mainBlock[targetKey].vol_te = value;
        console.log(`Горизонтальная вставка: значение ${value} в ${targetKey} (строка ${targetRowIndex + 1})`);
      } else {
        this.mainBlock[targetKey].vol_te = 0;
        console.log(`Горизонтальная вставка: некорректное значение ${value}, установлено 0 в ${targetKey}`);
      }
    }
  }

  applyPasteDataFromParent() {
    if (!this.pasteData || !this.isPasteTarget) {
      return;
    }

    console.log(`Применение данных вставки из родителя: ${this.pasteData.length}x${this.pasteData[0]?.length || 0} начиная с (${this.pasteStartRow}, ${this.pasteStartCol})`);

    this.applyMatrixToBlockWithOffset(this.pasteData, this.pasteStartRow, this.pasteStartCol);
  }

  applyMatrixToBlockWithOffset(matrix: number[][], startRow: number, startCol: number) {
    if (matrix.length === 0) {
      return;
    }

    if (matrix.length === 1 && matrix[0].length === 1) {
      const value = matrix[0][0];
      const targetKey = this.getKeyByRowIndex(startRow);
      
      if (targetKey && this.isRowEditable(startRow)) {
        if (this.mainBlock[targetKey]) {
          if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
            this.mainBlock[targetKey].vol_te = value;
            console.log(`Вставлено значение ${value} в ${targetKey}`);
          } else {
            this.mainBlock[targetKey].vol_te = 0;
            console.log(`Некорректное значение ${value}, установлено 0 в ${targetKey}`);
          }
        }
      }
    } else {
      const isHorizontal = matrix.length === 1 && matrix[0].length > 1;
      
      if (isHorizontal) {
        console.log('Обнаружена горизонтальная вставка из родителя');
        this.applyHorizontalMatrixWithOffset(matrix, startRow, startCol);
      } else {
        console.log('Обнаружена вертикальная вставка из родителя');
        this.applyVerticalMatrixWithOffset(matrix, startRow, startCol);
      }
    }

    Vue.nextTick(() => {
      const changes = {block: this.blockId, period: this.periodName};
      this.$emit('changes', changes);
    });
  }

  applyVerticalMatrixWithOffset(matrix: number[][], startRow: number, startCol: number) {
    for (let rowIndex = 0; rowIndex < matrix.length; rowIndex++) {
      const targetRowIndex = startRow + rowIndex;
      const targetKey = this.getKeyByRowIndex(targetRowIndex);
      
      if (!targetKey || !this.isRowEditable(targetRowIndex)) {
        console.log(`Строка ${targetRowIndex + 1} (${targetKey}) недоступна для редактирования`);
        continue;
      }
      
      const row = matrix[rowIndex];
      if (row.length === 0) continue;
      
      const colIndex = Math.min(startCol, row.length - 1);
      const value = row[colIndex];
      
      console.log(`Строка ${rowIndex + 1}: доступно ${row.length} столбцов, выбран столбец ${colIndex + 1}, значение: ${value}`);
      
      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        this.mainBlock[targetKey].vol_te = value;
        console.log(`Вставлено значение ${value} в ${targetKey} из столбца ${colIndex + 1}`);
      } else {
        this.mainBlock[targetKey].vol_te = 0;
        console.log(`Некорректное значение ${value}, установлено 0 в ${targetKey}`);
      }
    }
  }

  applyHorizontalMatrixWithOffset(matrix: number[][], startRow: number, startCol: number) {
    if (matrix.length === 0) return;
    
    const firstRow = matrix[0];
    if (!firstRow || firstRow.length === 0) return;
    
    console.log(`Горизонтальная вставка из родителя: ${firstRow.length} значений начиная с ${startRow + 1} строки`);
    
    for (let colIndex = 0; colIndex < firstRow.length; colIndex++) {
      const targetRowIndex = startRow + colIndex;
      const targetKey = this.getKeyByRowIndex(targetRowIndex);
      const value = firstRow[colIndex];
      
      if (!targetKey || !this.isRowEditable(targetRowIndex)) {
        console.log(`Строка ${targetRowIndex + 1} (${targetKey}) недоступна для редактирования`);
        continue;
      }
      
      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        this.mainBlock[targetKey].vol_te = value;
        console.log(`Горизонтальная вставка из родителя: значение ${value} в ${targetKey} (строка ${targetRowIndex + 1})`);
      } else {
        this.mainBlock[targetKey].vol_te = 0;
        console.log(`Горизонтальная вставка из родителя: некорректное значение ${value}, установлено 0 в ${targetKey}`);
      }
    }
  }
}
